import moment from 'moment';
import { EntityType } from 'UI/constants/entityTypes';

export const FORM_FIELDS_MAP = {
  TaskId: {
    key: 'id'
  },
  TaskType: {
    key: 'taskType',
    paramKey: 'taskTypeId',
    outboundAccesor: 'id'
  },
  Interview: {
    key: 'interview',
    paramKey: 'sendoutInterviewId',
    outboundAccesor: 'id',
    inboundAccesor: form => ({
      id: form.sendoutInterview?.id,
      companyName: form.sendoutInterview?.sendout?.jobOrder?.company?.name,
      candidateName: form.sendoutInterview?.sendout?.candidate?.personalInformation?.fullName,
      hiringAuthorityName: form.sendoutInterview?.sendout?.hiringAuthority?.fullname,
      interviewDate: form.sendoutInterview?.interviewDate,
      interviewId: form.sendoutInterview?.id,
      jobOrderTitle: form.sendoutInterview?.sendout?.jobOrder?.title,
      jobOrderStateTitle: form.sendoutInterview?.sendout?.jobOrder?.address?.vCity?.location,
      sendoutId: form.sendoutInterview?.sendoutId
    })
  },
  Comments: {
    key: 'comments'
  },
  IsCandidateSelected: {
    key: 'isSelected-candidate',
    inboundAccesor: form => form.entityType?.code === EntityType.Candidate
  },
  IsHiringAuthSelected: {
    key: 'isSelected-hiringAuthority',
    inboundAccesor: form => form.entityType?.code === EntityType.HiringAuthority
  },
  AtLeastOneContact: {
    key: 'atLeastOneContact'
  },
  StartDateTime: {
    key: 'callDateTime',
    inboundAccesor: form => moment(form.startDatetime)
  },
  EntityId: {
    key: 'entityId',
    inboundAccesor: 'entity.id'
  },
  Recruiter: {
    key: 'recruiter'
  }
};
